import { create as createStore } from "zustand"

const defaultState = {
  visible: false,
}

const store = createStore(() => defaultState)

export function useCartSidebarVisibile() {
  return store((state) => state.visible)
}

export function setCartSidebarVisible(visible: boolean) {
  store.setState({ visible })

  // The trustbadge has a 9999 z-index and is always visible.
  // We hide it when the cart sidebar is visible to avoid it overlapping.
  const trustbadge = document.querySelector("[id^='trustbadge-container-']") as HTMLDivElement | null

  if (trustbadge) {
    trustbadge.style.display = visible ? "none" : "block"
  }
}
